<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct1" id="toc_marker-5"><a href="#/OEBPS/Burgundy_Twisted_Roots2#Contents-A">Acknowledgments</a></p>
<p class="fp">I raise a glass to Barbara Peters and Robert Rosenfeld, editor and publisher of Poisoned Pen Press, their staff, and to the “posse,” the authors at PPP who provide so much support.</p>
<p class="body">I celebrate my agent, Kimberly Cameron of Kimberly Cameron Associates, every day. </p>
<p class="body">Deepest gratitude to the women who offered me a home away from home: Shannon Gilligan (Vermont), Colette Buret (Paris), and Nancy Ebersberg (Burgundy). </p>
<p class="body">In the U.S., Courtney Jenkins edited the early drafts, and Linda Tyler was my computer teacher. Kevin van Schaick taught me about guns. Heidi Gardner is my “girl on the red Vespa,” and Barbara Ensrud (b-e wine.com) and Honora Horan of HH Communications in New York were great connectors. </p>
<p class="body">My children, Luke and Ramsey Brown, are a constant source of inspiration, courage, and love.</p>
<p class="body">My French team went beyond all expectations. <em class="italic">Remercier vivement</em> to food and wine expert, Meg Bortin (<a class="calibre2" href="http://www.everydayfrenchchef.com" target="_blank">www.everydayfrenchchef.com</a>), and to winemakers Jean-Marie Chaland of Domaine des Chazelles, and his wife, Evelina; Esther Prunier of Domaine Michel Prunier et fille; and Marc Jessiaume of Domaine Chanzy. Tom Kevill-Davies was an entertaining and knowledgeable host in Auxey-Duresses. </p>
<p class="body">A highlight of my stay in Beaune was a private wine-tasting with Robert Drouhin of Maison Joseph Drouhin, and Ursula Bouchard, empress of Beaune. Valerie Drouhin was a gracious host. I am also grateful to French friends Simon Buret, Astrid Latapie, George Guthrie, and Jo Ann Landsman.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Burgundy_Twisted_Roots4.vue?aa9360c4